import { Box } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import CustomSelect from "../../../../../components/CustomSelect";
import ElevatedPaper from "../../../../../components/ElevatedPaper";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import AllFilePreview from "../../../../../components/ViewAllFile";
import CustomTitle from "../../../../../components/app/CustomTitle";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useQueryParams } from "../../../../../hooks/use-query-param";
import {
  DOCUMENT_REV_MAPPER,
  DOCUMENT_TABLE_MAPPER,
  DOCUMENT_TAGS,
  DOC_TYPE_MAPPER,
} from "../../../../../pages/app/provider/patient/patient-list/patient-chart-new/document/document-constant";
import { usePatientDocumentList } from "../../../../../queries/document/use-patient-document-list";
import { GetAllDocumentsDocumentTagEnum } from "../../../../../services";
import { formatDateTime } from "../../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
} from "../../../../../utils/utils";
import { DobAuthProvider } from "../DobAuthProvider";
import { getPublicRealm } from "../dob-validation/useValidateDob";

const PublicDocTable = () => {
  const patientId: any = useQueryParams("patientId");
  const viewDisclosure = useDisclosure();

  const xTENANTID = getPublicRealm();

  const [tag, setTag] = useState<GetAllDocumentsDocumentTagEnum>();

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { data: patientDocuments } = usePatientDocumentList({
    documentTag: tag,
    patientId: patientId,
    pagination,
    gridSorting,
    xTENANTID,
    isPublicView: true,
  });

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "documentDescription",
      headerName: "Document Title",
      flex: 0.6,
      width: 170,
      renderCell: ({ value, row }) => (
        <Text
          color="primary"
          onClick={() => viewDisclosure.open(row)}
          style={{ cursor: "pointer" }}
        >
          {value}
        </Text>
      ),
    },
    {
      field: "patientDocumentTags",
      headerName: "Document Tag",
      flex: 0.5,
      width: 160,
      renderCell: ({ value }) => DOCUMENT_TABLE_MAPPER[value],
    },
    {
      field: "documentFormat",
      headerName: "Document Type",
      flex: 0.5,
      width: 160,
      renderCell: ({ value }) => DOCUMENT_REV_MAPPER[value],
    },
    {
      field: "uploadedBy",
      headerName: "Uploaded By",
      flex: 0.5,
      width: 170,
    },
    {
      field: "uploadedAt",
      headerName: "Uploaded At",
      flex: 0.5,
      width: 170,
      renderCell: ({ value }) => (value ? formatDateTime(value) : "-"),
    },
  ]);

  return (
    <ElevatedPaper style={{ width: "100%", minHeight: "97svh" }}>
      <Flex flexDirection={"column"} width={"100%"} gap={1} p={0.5}>
        <AllFilePreview
          disclosureHost={viewDisclosure}
          file={viewDisclosure?.data?.document}
          fileType={
            DOC_TYPE_MAPPER[viewDisclosure.data?.documentFormat] ?? "other"
          }
          title="Preview Document"
          w="70vw"
        />

        <Flex justifyContent={"space-between"} height={"2.5rem"}>
          <CustomTitle>Documents</CustomTitle>

          <Flex gap={3}>
            <Box width={"250px"} height={"40px"}>
              <CustomSelect
                value={tag as any}
                placeholder="Select Tag"
                options={DOCUMENT_TAGS}
                onChange={(v) => setTag(v as any)}
              />
            </Box>
          </Flex>
        </Flex>

        <Box sx={{ height: "calc(100vh - 130px)" }}>
          <CustomDataGridV2
            getRowId={(row) => row?.uuid}
            rows={patientDocuments?.data?.content ?? []}
            rowCount={patientDocuments?.data?.page?.totalElements ?? 10}
            columns={COLUMNS}
            sx={{ marginTop: "40px" }}
            disableRowSelectionOnClick
            paginationModel={pagination}
            onPaginationModelChange={setPagination}
            onSortModelChange={setGridSorting}
          />
        </Box>
      </Flex>
    </ElevatedPaper>
  );
};

const PublicDocument = () => {
  return (
    <DobAuthProvider>
      <PublicDocTable />
    </DobAuthProvider>
  );
};

export default PublicDocument;
